import { SystemSettingsEntity } from 'api/types/entity';
import { yesOrNotOption } from 'helpers';
import { TFunc } from 'libs/i18n';

import { OnboardingSettingsFormType } from '../forms/onboardingSettingsForm';

export const getInitialValue = (
  t: TFunc,
  settings: SystemSettingsEntity
): OnboardingSettingsFormType => ({
  isAutomaticPersonalAccountGenerationEnabled: yesOrNotOption(
    t,
    settings.isAutomaticPersonalAccountGenerationEnabled
  ),
});
